﻿import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconCalendar } from "@tabler/icons-react";


export const DiasSemanaIcon = IconCalendar;
export const DiasSemanaHelpText = '* Aquí puede ver los dias de la semana.';

export class catDiasSemana extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "DiasSemana";
        this.def.columns.c_category_id.defaultValue = "DiasSemana";
        this.Title = "Dias de la Semana";
        this.HelpText = DiasSemanaHelpText;
        this.Icon = DiasSemanaIcon;
    }
}

